<template>
  <div class="invoice-flow__paywise">
    <div
      :style="{ 'background-image': `url(${image.icon})` }"
      :class="image.class"
      class="invoice-flow__paywise-logo"
    />
    <div class="invoice-flow__paywise-method">
      {{ $t('invoice_flow__paywise_cash') }}
    </div>
    <div class="invoice-flow__paywise-title">
      {{ $t('invoice_flow__paywise_cash_title') }}
      :
    </div>
    <div class="invoice-flow__paywise-steps">
      <div
        v-for="(step, index) in steps"
        v-html="`STEP ${index + 1}: ${step}`"
        :key="index"
        class="invoice-flow__paywise-steps__item"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PaywiseIcon from './assets/paywise.png';
import cloneDeep from 'lodash/cloneDeep';

export default {
  computed: {
    ...mapState(['flowData']),

    image() {
      const icon = ((this.flowData.payload || {}).method || {}).icon;
      return {
        icon: icon || PaywiseIcon,
        class: icon ? '' : 'custom',
      };
    },

    payload() {
      const { requisites } = cloneDeep(this.flowData.payload);

      let data = {
        invoice_id: null,
        phone: null,
        merchant_name: null,
        product_code: null,
      };

      if (requisites && typeof requisites === 'object') {
        Object.keys(data).forEach(key => {
          if (key in requisites) {
            data[key] = requisites[key];
          }
        });
      }

      Object.keys(data).forEach(key => {
        if (!data[key]) delete data[key];
      });
      return data;
    },

    steps() {
      const { invoice_id, phone, merchant_name, product_code } = this.payload;

      const { amount, currency } = this.flowData;

      return [
        this.$t('invoice_flow__paywise_cash_steps_step_1'),
        this.$t('invoice_flow__paywise_cash_steps_step_2', { merchant_name }),
        this.$t('invoice_flow__paywise_cash_steps_step_3', { product_code }),
        this.$t('invoice_flow__paywise_cash_steps_step_4', { phone }),
        this.$t('invoice_flow__paywise_cash_steps_step_5', { invoice_id }),
        this.$t('invoice_flow__paywise_cash_steps_step_6', {
          amount,
          currency,
        }),
      ];
    },
  },
};
</script>
<style lang="scss">
.invoice-flow__paywise {
  display: flex;
  flex-direction: column;
  align-items: center;
  &-method {
    margin-bottom: 50px;
  }

  &-logo {
    min-height: 4em;
    width: 19em;
    background-image: url(https://i.ibb.co/Pm1Vgsw/PW-Logo-High-Res-XXXX.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    margin-bottom: 20px;
  }
  &-title {
    font-weight: 700;
    font-size: 1.5em;
    margin-bottom: 1em;
  }
  &-steps {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &__item {
      line-height: 45px;
      font-style: 16px;

      span {
        font-size: 1.5em;
        font-weight: bold;
        color: green;
      }
    }
  }
}
</style>
